import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { combineLatest, of } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { State } from '../State';
import { getTravelZoneById, getTravelZonesActive, getTravelZonesFetched } from '../State/selectors/travel-zone.selector';

@Injectable({
    providedIn: 'root',
})
export class TravelZoneDataService {
    constructor(private store: Store<State>) {}
    getTravelZoneOptions$(requiredId?: number) {
        return combineLatest([this.store.select(getTravelZonesFetched).pipe(filter((f) => f)), this.store.select(getTravelZonesActive), requiredId ? this.store.select(getTravelZoneById({ id: requiredId })) : of(null)]).pipe(
            map(([fetched, travelZones, reqiredTravelZone]) => {
                if (!reqiredTravelZone || travelZones.some((t) => t.Id === reqiredTravelZone.Id)) {
                    return travelZones;
                } else {
                    return [...travelZones, reqiredTravelZone];
                }
            }),
        );
    }
}
